import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const auth = getAuth();
            await sendPasswordResetEmail(auth, email);
            setSent(true);
        } catch (err) {
            console.error('Password reset error:', err);
            if (err.code === 'auth/user-not-found' || err.code === 'auth/invalid-email') {
                setError('Bu e-posta adresiyle kayıtlı bir hesap bulunamadı.');
            } else if (err.code === 'auth/too-many-requests') {
                setError('Çok fazla deneme yapıldı. Lütfen bir süre bekleyin.');
            } else {
                setError('Bir hata oluştu. Lütfen tekrar deneyin.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full min-h-screen bg-gray-50 flex flex-col items-center justify-center py-10 px-4">
            <div className="w-full max-w-md bg-white shadow-lg rounded-lg px-8 py-8">
                <h2 className="text-2xl font-bold mb-2 text-center">Şifremi Unuttum</h2>
                <p className="text-gray-500 text-sm text-center mb-6">
                    E-posta adresinizi girin; şifre sıfırlama bağlantısı göndereceğiz.
                </p>

                {sent ? (
                    <div className="text-center">
                        <div className="bg-green-50 border border-green-200 rounded-lg p-5 mb-6">
                            <p className="text-green-700 font-semibold mb-1">E-posta gönderildi!</p>
                            <p className="text-green-600 text-sm">
                                <strong>{email}</strong> adresine şifre sıfırlama bağlantısı gönderildi.
                                Gelen kutunuzu (ve spam klasörünüzü) kontrol edin.
                            </p>
                        </div>
                        <Link
                            to="/login"
                            className="inline-block w-full bg-black text-white py-2.5 rounded-lg hover:bg-gray-800 transition-colors font-medium text-center"
                        >
                            Giriş Sayfasına Dön
                        </Link>
                    </div>
                ) : (
                    <>
                        {error && (
                            <p className="bg-red-100 text-red-700 p-3 rounded mb-4 text-sm">{error}</p>
                        )}
                        <form onSubmit={handleSubmit}>
                            <div className="mb-5">
                                <label className="block text-gray-700 mb-2 text-sm font-medium" htmlFor="email">
                                    E-posta Adresi
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="ornek@email.com"
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black"
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full bg-black text-white py-2.5 rounded-lg hover:bg-gray-800 disabled:opacity-50 transition-colors font-medium"
                            >
                                {loading ? 'Gönderiliyor...' : 'Sıfırlama Bağlantısı Gönder'}
                            </button>
                        </form>
                        <p className="text-center text-sm text-gray-600 mt-5">
                            Şifrenizi hatırladınız mı?{' '}
                            <Link to="/login" className="text-blue-500 hover:text-blue-700 font-medium">
                                Giriş Yap
                            </Link>
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
